import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";

import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import SmoothScroll from "@/components/SmoothScroll";
import AnnouncementBar from "@/components/AnnouncementBar";
import PageviewTracker from "@/components/PageviewTracker";
import BrandSplash from "@/components/BrandSplash";
import PageTransition from "@/components/PageTransition";
import ScrollProgress from "@/components/ScrollProgress";
import CustomCursor from "@/components/CustomCursor";

import Home from "@/pages/Home";
import ChiSiamo from "@/pages/ChiSiamo";
import Hotels from "@/pages/Hotels";
import HotelDetail from "@/pages/HotelDetail";
import NuoveAperture from "@/pages/NuoveAperture";
import News from "@/pages/News";
import NewsDetail from "@/pages/NewsDetail";
import Contatti from "@/pages/Contatti";
import Investor from "@/pages/Investor";
import MercatoMilano from "@/pages/MercatoMilano";
import LegalPage from "@/pages/LegalPage";
import CantiereGateway from "@/pages/CantiereGateway";
import TheCathedral from "@/pages/TheCathedral";
import CookieBanner from "@/components/CookieBanner";

import AdminLogin from "@/admin/AdminLogin";
import AdminLayout from "@/admin/AdminLayout";
import AdminDashboard from "@/admin/AdminDashboard";
import AdminHotels from "@/admin/pages/AdminHotels";
import AdminOpenings from "@/admin/pages/AdminOpenings";
import AdminNews from "@/admin/pages/AdminNews";
import AdminDocuments from "@/admin/pages/AdminDocuments";
import AdminMessages from "@/admin/pages/AdminMessages";
import AdminMedia from "@/admin/pages/AdminMedia";
import AdminSettings from "@/admin/pages/AdminSettings";
import AdminBeforeAfter from "@/admin/pages/AdminBeforeAfter";
import AdminAnalytics from "@/admin/pages/AdminAnalytics";
import AdminMarquee from "@/admin/pages/AdminMarquee";
import AdminMarket from "@/admin/pages/AdminMarket";
import AdminPages from "@/admin/pages/AdminPages";
import AdminAccessCodes from "@/admin/pages/AdminAccessCodes";
import AdminInvestorSections from "@/admin/pages/AdminInvestorSections";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);
  return null;
}

function PublicLayout({ children }) {
  return (
    <>
      <BrandSplash />
      <CustomCursor />
      <ScrollProgress />
      <SmoothScroll />
      <ScrollToTop />
      <PageviewTracker />
      <AnnouncementBar />
      <Navbar />
      <main>
        <PageTransition>{children}</PageTransition>
      </main>
      <Footer />
      <CookieBanner />
    </>
  );
}

function AdminRoutes() {
  return (
    <Routes>
      <Route path="login" element={<AdminLogin />} />
      <Route path="" element={<AdminLayout />}>
        <Route index element={<AdminDashboard />} />
        <Route path="hotels" element={<AdminHotels />} />
        <Route path="openings" element={<AdminOpenings />} />
        <Route path="news" element={<AdminNews />} />
        <Route path="messages" element={<AdminMessages />} />
        <Route path="documents" element={<AdminDocuments />} />
        <Route path="media" element={<AdminMedia />} />
        <Route path="before-after" element={<AdminBeforeAfter />} />
        <Route path="marquee" element={<AdminMarquee />} />
        <Route path="market" element={<AdminMarket />} />
        <Route path="pages" element={<AdminPages />} />
        <Route path="access-codes" element={<AdminAccessCodes />} />
        <Route path="investor-sections" element={<AdminInvestorSections />} />
        <Route path="analytics" element={<AdminAnalytics />} />
        <Route path="settings" element={<AdminSettings />} />
      </Route>
    </Routes>
  );
}

function App() {
  return (
    <div className="App bg-[#08080A] text-white min-h-screen">
      <BrowserRouter>
        <Routes>
          <Route path="/admin/*" element={<AdminRoutes />} />
          <Route
            path="/*"
            element={
              <PublicLayout>
                <Routes>
                  <Route path="/" element={<Home />} />
                  <Route path="/chi-siamo" element={<ChiSiamo />} />
                  <Route path="/hotel" element={<Hotels />} />
                  <Route path="/hotel/:slug" element={<HotelDetail />} />
                  <Route path="/nuove-aperture" element={<NuoveAperture />} />
                  <Route path="/nuove-aperture/gateway-hotel/cantiere" element={<CantiereGateway />} />
                  <Route path="/nuove-aperture/the-cathedral" element={<TheCathedral />} />
                  <Route path="/mercato-milano" element={<MercatoMilano />} />
                  <Route path="/news" element={<News />} />
                  <Route path="/news/:slug" element={<NewsDetail />} />
                  <Route path="/contatti" element={<Contatti />} />
                  <Route path="/investor" element={<Investor />} />
                  <Route path="/privacy-policy" element={<LegalPage pageKey="privacy-policy" fallbackTitle="Privacy Policy" />} />
                  <Route path="/cookie-policy" element={<LegalPage pageKey="cookie-policy" fallbackTitle="Cookie Policy" />} />
                </Routes>
              </PublicLayout>
            }
          />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
